import GetUrlApi from "../UrlApi";
import { BUILD_ID } from "../buildInfo";

/**
 * Construye la URL de un hub SignalR añadiendo los query params necesarios para
 * que el backend una la conexión a los grupos correspondientes en OnConnectedAsync:
 *   - restauranteId → grupo "restaurante-{id}"
 *   - sessionId     → grupo "session-{id}"
 *
 * Desde que los hubs emiten vía `Clients.Group(...)` en vez de `Clients.All`,
 * una conexión sin estos params NO recibirá los broadcasts. Cada hook del front
 * DEBE pasar el contexto que le aplique.
 *   - mesaId        → grupo "mesa-{id}" (solo startsessionhub: el comensal
 *                     escucha únicamente los eventos de su mesa)
 *
 * Los params solo indican qué contexto pide el cliente: el backend decide los
 * grupos por el JWT (accessTokenFactory en HubConnectionManager) e ignora un
 * restauranteId/sessionId que no sea del token.
 */
export default function buildHubUrl(path, { restauranteId, sessionId, mesaId, deviceId } = {}) {
  const base = `${GetUrlApi()}${path.startsWith("/") ? path : `/${path}`}`;
  const params = new URLSearchParams();
  if (restauranteId) params.set("restauranteId", restauranteId);
  if (sessionId) params.set("sessionId", sessionId);
  if (mesaId) params.set("mesaId", mesaId);
  // Fase 4 · `/hub/tpv`: el dispositivo (SessionIdentifier) para el origen
  // de los eventos y el grupo del dispositivo.
  if (deviceId) params.set("deviceId", deviceId);
  // 2026-10-05 · Versión del build del dispositivo (Admin › Versiones). Va en
  // la misma URL que comparten useTpvRealtime y el puente legacy (misma conexión).
  if (deviceId) params.set("v", BUILD_ID);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}
